import { useState } from 'react';
import dayjs from '@/helpers/dayjs';
import PeriodPopover from './periodPopover';
import { dayClass as lightDayClass, todayDotClass } from './lightUi';

function ChoiceByDay({
 item, calendarCurrent = {}, store, onSelected, light, labels,
}) {
  const [openPopover, setOpenPopover] = useState(false);

  const dateCurrent = dayjs(item.date);

  const fnPeriodAvailable = () => {
    const available = {
      d: true, m: true, a: true, n: true, disabled: '',
    };

    return available;
  };

  const fnDateIsSelected = () => store.getDatesPicked().indexOf(dateCurrent.formatAsKey()) > -1;
  // garbage function, juste for dev
  const getPeriodDateCurrent = () => store.getPeriod()[dateCurrent.formatAsKey()];

  const fnDateIsDisable = () => {
    // datecurrent isover
    if (store.isPast(dateCurrent)) return true;
    // datecurrent isn't same current month
    if (!dateCurrent.isSame(calendarCurrent.date, 'months')) return true;
    // day of week not filled
    return false;
  };

  const periodAvailable = fnPeriodAvailable();
  // if no available period => day disable, else check fnDateIsDisable
  const dateIsDisable = !(periodAvailable.disabled !== true) || fnDateIsDisable();
  const dateIsSelected = fnDateIsSelected();
  const isToday = dateCurrent.isSame(dayjs(), 'day');
  const classes = `cursor-pointer relative day text-center ${periodAvailable.disabled === true
    ? ''
    : periodAvailable.disabled}`;

  const onClickOpenPopover = () => {
    setOpenPopover(true);
  };

  function renderPopover() {
    if (!openPopover) return null;
    return (
      <PeriodPopover
        {...{
          item, periodAvailable, store, light, labels,
        }}
        onClose={() => {
          onSelected?.();
          setTimeout(() => {
            setOpenPopover(false);
          }, 5);
        }}
      />
    );
  }

  /*
    Variante claire : jour sélectionné = pastille violette pleine (la période ou le créneau
    est détaillé dans la liste sous le calendrier), jour ouvert = violet pâle, aujourd'hui
    = point sous le chiffre.
  */
  let dayClass;
  if (light) {
    dayClass = lightDayClass({ disabled: dateIsDisable, selected: dateIsSelected, open: openPopover });
  } else {
    dayClass = `transition flex period-black-${getPeriodDateCurrent()} items-center justify-center h-9 w-9 my-[2px] block rounded-lg hover:bg-purple-5 ${openPopover ? 'text-purple bg-purple-5' : 'text-purple-4 hover:text-purple'} ${dateIsDisable ? 'font-normal text-purple-4/30' : ''}`;
  }

  return (
    <td
      data-selected={dateIsSelected}
      data-disabled={dateIsDisable}
      className={classes}
    >
      <div className={`flex items-center justify-center ${light ? 'py-[1px]' : ''}`}>
        <div
          className={dayClass}
          {...(dateIsDisable ? {} : { onClick: onClickOpenPopover })}
        >
          <span>
            {dateCurrent.date()}
            {dateIsSelected}
          </span>
          {light && isToday && !dateIsSelected && (
            <span className={todayDotClass} aria-hidden="true" />
          )}
        </div>
      </div>
      {renderPopover()}
    </td>
  );
}

export default ChoiceByDay;
